import { useEffect, useState } from 'react';

/**
 * Phones with little height (a small phone, or Safari with its bars showing)
 * get one nudge in the letters list instead of the extra header content.
 * Measured on the visual viewport, which is what is actually left to read in.
 */
export const SHORT_SCREEN_MAX = 760;

export function isShortScreen(height: number): boolean {
  return height > 0 && height < SHORT_SCREEN_MAX;
}

function viewportHeight(): number {
  if (typeof window === 'undefined') return 0;
  return window.visualViewport?.height ?? window.innerHeight;
}

export function useShortScreen(): boolean {
  const [short, setShort] = useState(() => isShortScreen(viewportHeight()));
  useEffect(() => {
    const on = () => setShort(isShortScreen(viewportHeight()));
    on();
    const vv = window.visualViewport;
    vv?.addEventListener('resize', on);
    window.addEventListener('resize', on);
    window.addEventListener('orientationchange', on);
    return () => {
      vv?.removeEventListener('resize', on);
      window.removeEventListener('resize', on);
      window.removeEventListener('orientationchange', on);
    };
  }, []);
  return short;
}
